import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
// Removed ParticlesAuth import
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { PocketBaseContext } from '../../PocketBaseContext';

import logoLight from "../../assets/images/logo.png";

// PocketBase kimlik doğrulama bileşeni
const Login = () => {
    document.title = "Login | Reform Panel";
    const pb = useContext(PocketBaseContext);
    const navigate = useNavigate();
    const [userLogin, setUserLogin] = useState({ email: '', password: '' });
    const [passwordShow, setPasswordShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        if (pb?.authStore?.isValid) {
            navigate('/reform-dashboard');
        }
    }, [pb, navigate]);

    useEffect(() => {
        if (errorMsg) {
            const timer = setTimeout(() => {
                setErrorMsg("");
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [errorMsg]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: userLogin.email || "email@local.com",
            password: userLogin.password || "test.test",
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Lütfen E-posta Adresinizi Girin").email("Geçerli bir e-posta adresi girin"),
            password: Yup.string().required("Lütfen Şifrenizi Girin"),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            setErrorMsg("");
            try {
                const authData = await pb.collection('users').authWithPassword(values.email, values.password);
                setLoading(false);
                console.log(authData);
                navigate('/reform-dashboard');
            } catch (error) {
                setLoading(false);
                if (error.data?.message) {
                    setErrorMsg(error.data.message);
                } else {
                    setErrorMsg("Giriş başarısız. Lütfen tekrar deneyin.");
                }
            }
        }
    });

    return (
        <React.Fragment>
            <div className="auth-page-content mt-lg-5">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center mt-sm-5 mb-4 text-white-50">
                                <div>
                                    <Link to="/" className="d-inline-block auth-logo">
                                        <img src={logoLight} alt="" height="175" />
                                    </Link>
                                </div>
                                <p className="mt-3 fs-15 fw-medium">Reform Panel Dashboard</p>
                            </div>
                        </Col>
                    </Row>

                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="mt-4">
                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        <h5 className="text-primary">Hoş Geldiniz!</h5>
                                        <p className="text-muted">Reform Panel'e devam etmek için giriş yapın.</p>
                                    </div>
                                    {errorMsg && (<Alert color="danger">{errorMsg}</Alert>)}
                                    <div className="p-2 mt-4">
                                        <Form onSubmit={validation.handleSubmit} action="#">
                                            <div className="mb-3">
                                                <Label htmlFor="email" className="form-label">E-posta</Label>
                                                <Input
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="E-posta adresini girin"
                                                    type="email"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.email || ""}
                                                    invalid={validation.touched.email && validation.errors.email}
                                                />
                                                {validation.touched.email && validation.errors.email ? (
                                                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="mb-3">
                                                <div className="float-end">
                                                    <Link to="/forgot-password" className="text-muted">Şifremi unuttum?</Link>
                                                </div>
                                                <Label className="form-label" htmlFor="password-input">Şifre</Label>
                                                <div className="position-relative auth-pass-inputgroup mb-3">
                                                    <Input
                                                        name="password"
                                                        value={validation.values.password || ""}
                                                        type={passwordShow ? "text" : "password"}
                                                        className="form-control pe-5"
                                                        placeholder="Şifre Girin"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        invalid={validation.touched.password && validation.errors.password}
                                                    />
                                                    {validation.touched.password && validation.errors.password ? (
                                                        <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                    ) : null}
                                                    <button
                                                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                                        type="button"
                                                        id="password-addon"
                                                        onClick={() => setPasswordShow(!passwordShow)}
                                                    >
                                                        <i className="ri-eye-fill align-middle"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="form-check">
                                                <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                <Label className="form-check-label" htmlFor="auth-remember-check">Beni hatırla</Label>
                                            </div>

                                            <div className="mt-4">
                                                <Button color="success" disabled={loading} className="btn btn-success w-100" type="submit">
                                                    {loading ? <Spinner size="sm" className='me-2'> Yükleniyor... </Spinner> : null}
                                                    Giriş Yap
                                                </Button>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>

                            <div className="mt-4 text-center">
                                <p className="mb-0">Hesabınız yok mu? <Link to="/register" className="fw-semibold text-primary text-decoration-underline"> Kaydol </Link> </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Login;